<template>
  <v-text-field
    v-bind="{
      height: 48,
      dense: true,
      solo: true,
      flat: true,
      clearable: true,
      hideDetails: true,
      backgroundColor: 'bg-gray-40',
      class: 'core-search-field',
      'data-qa': 'core-search-field',
      ...$attrs,
    }"
    v-on="{
      ...$listeners,
      input: handleInput,
    }"
  >
    <template #prepend-inner>
      <slot name="prepend-inner">
        <v-icon
          size="20"
          class="icon-secondary--text mr-2"
        >
          ui-icon-search
        </v-icon>
      </slot>
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { useListeners } from 'vue'
import { debounce } from 'lodash'

const props = defineProps<{
  debounceMs?: number
}>()

const emit = defineEmits([
  'input',
  'input:debounced',
])

const listeners = useListeners()

const debouncedEmit = debounce((e: string) => {
  emit('input:debounced', e)
}, props.debounceMs ?? 250)

const handleInput = (e: string | null) => {
  const value = e ?? ''

  emit('input', value)

  if (listeners['input:debounced']) {
    // Если поле очистили через крестик, то задержку не делаем
    if (e === null) {
      emit('input:debounced', '')
    } else {
      debouncedEmit(value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'www/themes/doctors/common/variables';

.core-search-field {
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

  &:hover {
    box-shadow: 0 0 0 1px $ui-kit-primary;
  }

  &.v-input--is-focused {
    box-shadow: 0 0 0 2px $ui-kit-primary;
    caret-color: $ui-kit-primary;
  }

  :deep(input)::placeholder {
    color: $ui-kit-text-info;
  }
}
</style>
